import * as yup from "yup";

const cancelTripRequestValidator = yup
  .object({ reason: yup.string().required("Reason is required") })
  .required();

export default cancelTripRequestValidator;
